import React from "react";
import { Box, colors, IconButton, makeStyles } from "@material-ui/core";

import { FormattedMessage, useIntl } from "react-intl";
import ExpandMoreOutlined from "@material-ui/icons/ExpandMore";
import { CustomTooltip } from "./Tooltip";

const useStyles = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    paddingTop: theme.spacing(0.6),
    paddingBottom: theme.spacing(0.6),
  },

  actions: {},

  actionsPrev: {
    transform: "rotate(90deg)",
    marginLeft: "auto",
    marginRight: 4,
    color: colors.grey[800],
  },

  actionsNext: {
    transform: "rotate(-90deg)",
    marginLeft: "auto",
    color: colors.grey[800],
  },

  titles: {
    fontSize: 13,
    color: colors.grey[800],
    marginRight: 20,
  },
}));

export interface PaginationActionsProps
  extends React.HTMLAttributes<HTMLDivElement> {
  count: number;
  onChangePage: (page: number) => void;
  page: number;
  rowsPerPage: number;
}

const PaginationActions = (props: PaginationActionsProps) => {
  const classes = useStyles();
  const intl = useIntl();
  const { count, page, rowsPerPage, onChangePage } = props;

  const handleBackButtonClick = (event: any) => {
    onChangePage(page - 1);
  };

  const handleNextButtonClick = (event: any) => {
    onChangePage(page + 1);
  };

  return (
    <Box
      component="div"
      display="flex"
      alignItems="center"
      justifyContent="end"
      className={classes.root}
    >
      <Box component="div">
        <Box component="div" className={classes.titles}>
          <FormattedMessage
            id="sharedScreen.paginatorTitles"
            values={{
              page: page + 1,
              count: count,
              totalPages: Math.ceil(count / rowsPerPage),
            }}
          />
        </Box>
      </Box>
      <Box className={classes.actions}>
        <CustomTooltip
          title={intl.formatMessage({ id: "sharedScreen.prev" })}
          arrow
        >
          <IconButton
            className={classes.actionsPrev}
            onClick={handleBackButtonClick}
            disabled={page === 0}
          >
            <ExpandMoreOutlined
              fontSize="small"
              titleAccess={intl.formatMessage({
                id: "sharedScreen.previous",
              })}
            />
          </IconButton>
        </CustomTooltip>

        <CustomTooltip
          title={intl.formatMessage({ id: "sharedScreen.next" })}
          arrow
        >
          <IconButton
            onClick={handleNextButtonClick}
            className={classes.actionsNext}
            disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          >
            <ExpandMoreOutlined
              fontSize="small"
              titleAccess={intl.formatMessage({ id: "sharedScreen.next" })}
            />
          </IconButton>
        </CustomTooltip>
      </Box>
    </Box>
  );
};

export default PaginationActions;
